import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AppService } from 'src/app/app.service';
import { UtilsService } from 'src/app/shared/utils.service';
import { RBACService } from '../../../shared/rbac.service';

@Component({
  selector: 'app-employees-notifications-tabs',
  templateUrl: './employees-notifications-tabs.component.html',
  styleUrls: ['./employees-notifications-tabs.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class EmployeesNotificationsTabsComponent implements OnInit {
  // The user id.
  user_id: number;

  // RBAC permission flags. Resolved once in ngOnInit() so the template does not
  // re-evaluate permission checks on every change detection cycle.
  canEditNotificationRoles: boolean = false;
  canViewNotificationRoles: boolean = false;
  canViewSites: boolean = false;

  constructor(
    public app: AppService,
    public utils: UtilsService,
    public route: ActivatedRoute,
    public rbac: RBACService
  ) {}

  // Expose RBACService to template.
  protected readonly RBACService = RBACService;

  ngOnInit(): void {
    // Resolve the RBAC permission flags used by the template.
    this.canEditNotificationRoles = this.rbac.userCanAccess(
      [
        RBACService.getPermission(
          RBACService.RBAC_F.F_ACCOUNT_NOTIFICATION_ROLES,
          RBACService.RBAC_A.A_EDIT
        )
      ],
      true
    );
    this.canViewNotificationRoles = this.rbac.userCanAccess(
      [
        RBACService.getPermission(
          RBACService.RBAC_F.F_ACCOUNT_NOTIFICATION_ROLES,
          RBACService.RBAC_A.A_VIEW
        )
      ],
      true
    );
    this.canViewSites = this.rbac.userCanAccess(
      [
        RBACService.getPermission(
          RBACService.RBAC_F.F_SITES,
          RBACService.RBAC_A.A_VIEW
        )
      ],
      true
    );

    // Get the user id from the route params.
    this.user_id = Number(this.route.parent.snapshot.params['user_id']);
  }
}
